export default __webpack_public_path__ + "static/women2-c72a991a94a8a134a31671ed35f2165c.webp";